export default __webpack_public_path__ + "static/media/1800.8030548f.png";